import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-services-overview',
    templateUrl: 'services-overview.component.html',
    styleUrls: ['../pages.scss', 'services-overview.component.scss'],
})

export class ServicesOverviewComponent {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => this.activeLanguage = val);
    }
    content = {
        german: `<div class="row">
        <div class="col">
            <h1 class="header">TCW Leistungen im Überblick</h1>
        </div>
    </div>
          <div class="row">
            <div class="text-content col">
                <p class="start-indent">
                    Das Leistungsspektrum der <span class="highlight">Technologie Consulting Wolke</span> umfasst gleichermaßen strategische
                    wie auch operative Themen. Wir sind der richtige Ansprechpartner, gleich ob Sie Ihre Geschäftsabläufe in Entwicklung und
                    Produktion generell optimieren wollen, oder konkrete Unterstützung zur Bearbeitung spezifischer technologischer und operativer
                    Fragestellungen benötigen, z. B. bei:
                </p>
              <ul>
                <li>Der Geschäftsentwicklung technologisch anspruchsvoller Produkte von der Produktidee über Umsetzung bis zur erfolgreichen Markteinführung</li>
                <li>Dem Aufbau und der Qualifikation neuer Produktionslinien</li>
                <li>Der Einführung neuer Produktionstechniken und Technologien speziell im Bereich der sauberen Fertigung in reiner Umgebung</li>
                <li>Der kosten- und zeitgerechten, strukturierten Durchführung von Entwicklungsprojekten</li>
                <li>Der Konzeptionierung und Durchführung von Zuverlässigkeitsanalysen</li>
                <li>der Einführung und Implementierung von „best practice“- Methoden (z.B. Six Sigma design, FMEA, PPAP, Risikoanalysen)</li>
                <li>Dem Aufsatz, der Strukturierung und der Leitung von Projekten</li>
                <li>Dem Aufbau und Begleitung von Projektteams (Coaching)</li>
                <li>Dem Auffinden und Beseitigen von Schwachstellen im Entwicklungs- und Produktionsumfeld</li>
                <li>Verbesserung der Zusammenarbeit mit Partnern, intern und extern</li>
              </ul>
            </div>
            </div>`,
      english: `
      <div class="row">
      <div class="col">
          <h1 class="header">TCW Leistungen im Überblick</h1>
      </div>
  </div>
        <div class="row">
          <div class="text-content col-12">
              <p>
                  The <span class="highlight">Technologie Consulting Wolke</span> spectrum of services includes both strategic
                  and operational focus. Therefore TCW is the right partner whether we work on improving our client’s business
                  processes in R&D and production in general terms or provide support in solving specific technological and
                  operational problems. TCW has a proven record of successful consultancy in:
              </p>
            <ul>
              <li>Strategic business development for technology based products starting with the basic
                idea via product definition and development up to successful market introduction.</li>
              <li>Startup and qualification of new production lines.</li>
              <li>Introduction of new technologies and production techniques especially for contamination free manufacturing in clean environments.</li>
              <li>In-time and in-budget execution of development projects.</li>
              <li>Conceptual design and execution of reliability analysis</li>
              <li>Introduction and implementation of "best-practice"-methods (e.g. Six Sigma design, FMEA, PPAP, risk analysis)</li>
              <li>Interim project management and project responsibility</li>
              <li>Formation, enabling and coaching of project teams</li>
              <li>Identify weaknesses and un-used potentials in R&D and manufacturing environment</li>
              <li>Establish sustainable work relations with internal and external suppliers and business partners</li>
            </ul>
          </div>
          </div>`,
    };

}


// WEBPACK FOOTER //
// ./src/app/components/services-overview/services-overview.component.ts